<template src="./html/Datatable.html"></template>

<script>
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	import FilterBar from './FilterBar'
	import VueElementLoading from 'vue-element-loading'
	import _ from 'lodash'
	import Actions from './Actions'

	export default {
		props: ['isAuth', 'user', 'project'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'actions': Actions,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/customers/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							allowDate: false,
							date: null,
							author_id: null,
							project_id: null,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
							visible: !this.$platform.setting.customers.custom_reference
						},
						{
							name: '__slot:reference',
							title: 'Ref.',
							sortField: 'reference',
							visible: this.$platform.setting.customers.custom_reference
						},
						{
							name: '__slot:name',
							title: 'Nombre',
							sortField: 'name',
						},
						{
							name: '__slot:company',
							title: 'Empresa',
							sortField: 'company',
							visible: this.$platform.setting.customers.display_company
						},
						{
							name: '__slot:email',
							title: 'E-mail',
							sortField: 'email',
						},
						{
							name: '__slot:mobile',
							title: 'Móvil',
							sortField: 'mobile',
						},
						{
							name: '__slot:phone',
							title: 'Teléfono',
							sortField: 'phone',
							visible: false,
						},
						{
							name: '__slot:places',
							title: 'Localización',
						},
						{
							name: '__slot:author',
							title: 'Autor',
							sortField: 'author_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY')
							},
						},
						{
							name: '__slot:printed',
							title: '<i class="fa fa-print" aria-hidden="true"></i>',
							sortField: 'printed',
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		watch: {
			'$route'() {
				this.loadQuery()
				this.reload()
			}
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.loadQuery()
				if(this.project) {
					this.datatable.moreParams.filter.project_id = this.project.id
				}
			},
			loadQuery() {
				if(this.$route.query) {
					if(this.$route.query.text) {
						this.datatable.moreParams.filter.text = this.$route.query.text
					}
					if(this.$route.query.date) {
						this.datatable.moreParams.filter.allowDate = true
						this.datatable.moreParams.filter.date = this.$route.query.date
					}
				}
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				this.datatable.moreParams.filter.author_id = null
				this.$router.replace({'query': null})
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/' + to
					}
				} else {
					var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
				}

				return to
			},
			printedString(data) {
				var title = null
				if(data.printed_at) {
					title = this.$options.filters.moment(data.printed_at)
					if(data.printer) {
						if(data.printer.profile) {
							title += ' - ' + data.printer.profile.first_name + ' ' + data.printer.profile.last_name
						}
					}
				}
				return title
			},
			destroy(data) {
				this.$emit('destroy', data)
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Datatable.vue